import RpcService              from '@/core/services/Rpc/RpcService';
import RpcResponse             from '@/core/services/Rpc/RpcResponse';

import type TransportZone      from '@/domains/TransportZones/TransportZone';
import type RpcDataPagination  from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort        from '@/core/services/Rpc/RpcDataSort';

/**
 * DAO для работы с транспортными зонами
 */
class TransportZonesDAO {

	/**
	 * Загружает одну транспортную зону по ID
	 */
	static async get(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('transportZones.get', { id });
	}

	/**
	 * Загружает список транспортных зон
	 */
	static async getList(
		filters?: { pattern?: string },
		pagination?: RpcDataPagination,
		sort?: RpcDataSort,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest(
			'transportZones.getList',
			filters,
			pagination,
			sort,
			true, null, null, false,
			{ abortPrevious: true },
		);
	}

	/**
	 * Создаёт транспортную зону
	 */
	static async add(transportZone: TransportZone): Promise<RpcResponse> {
		return await RpcService.makeRequest('transportZones.add', { transportZone });
	}

	/**
	 * Обновляет транспортную зону
	 */
	static async update(transportZone: TransportZone): Promise<RpcResponse> {
		return await RpcService.makeRequest('transportZones.update', { transportZone });
	}

	/**
	 * Удаляет транспортную зону (soft delete)
	 */
	static async delete(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('transportZones.delete', { id });
	}
}

export default TransportZonesDAO;
